import { render } from "./RecursiveJSONTemplate.vue?vue&type=template&id=1c133045&scoped=true"
import script from "./RecursiveJSONTemplate.vue?vue&type=script&lang=js"
export * from "./RecursiveJSONTemplate.vue?vue&type=script&lang=js"

import "./RecursiveJSONTemplate.vue?vue&type=style&index=0&id=1c133045&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c133045"]])

export default __exports__